import { render, staticRenderFns } from "./ProcessWorkflow.vue?vue&type=template&id=90ed9556&"
import script from "./ProcessWorkflow.vue?vue&type=script&lang=js&"
export * from "./ProcessWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports